<template>
	<div class="answer">
        <div></div>
		<div class="answer_content">
			<div class="content_list">
                <ti :list_a="result" :activityid='activityid' @transfer = 'postAnswer'></ti>
			</div>
		</div>
	</div>
</template>

<script>
import ti from './ti.vue'
	import {
		getAnswerListAll,
		getByCode,
		answerSubmit,
		answerCheck,
        getUserParticipateInfo,
        getUserQrCode
	} from '@/api/activity.js'
	export default {
		data() {
			return {
				form: {
					type: [],
				},
				activityid: '',
				result: [],
				resultList: [],
				num: 0,
				//答案显示
				is_show: false,
				//背景显示
				bg_show: true,
				//每题答案是否正确
				AnswerOne: '',
				AnswerTwo: '',
				AnswerThree: '',
				AnswerFore: '',
				AnswerFive: '',
				correctNumber: '',
				//图片路径
				img_show1:false,
				img_show2:false,
				img_show3:false,
				img_show:false,
                levelLogo:'',
				levelName:'',
                correctAnswerNumDesc:'',
                rewardDesc:'',
                rewardEffective:'',
                valueDesc:'',
                qrCode:'',
				answerQrShow:false,
				isShowDatisuccess:false,
			}
		},
		components: {
			ti
		},
		mounted() {

			this._getByCode();

			// this.getAnswerlist();

			// this._answerCheck();
			// this._answerSubmit();

		},
		methods: {
            postAnswer(msg){
                console.log(msg)
            },
			enterQr(){
				this.answerQrShow=true;
			},
			leaveQr(){
				this.answerQrShow=false;
			},
			closeBg() {
				this.bg_show = false;
				this.$router.push('/huodong/zhishichanquanri.html')
			},
			subAnswer() {
				// var id1 = '';
				// var id2 = '';
				// var id3 = '';
				// var id4 = '';
				// var id5 = '';
				// var num = 0
				// this.form.type.forEach(item => {
				// 	let a = item.split('')

				// 	if (a[0] == 1) {
				// 		id1 += a[1] + ','
				// 	} else if (a[0] == 2) {
				// 		id2 += a[1] + ','
				// 	} else if (a[0] == 3) {
				// 		id3 += a[1] + ','
				// 	} else if (a[0] == 4) {
				// 		id4 += a[1] + ','
				// 	} else if (a[0] == 5) {
				// 		id5 += a[1] + ','
				// 	}

				// })
				var answer1 = '';
				var answer2 = '';
				var answer3 = '';
				var answer4 = '';
				var answer5 = '';
				var num = 0
				this.form.type.forEach(item => {
					let a = item.split('')

					if (a[0] == 1) {
						answer1 += a[1] + ','
					} else if (a[0] == 2) {
						answer2 += a[1] + ','
					} else if (a[0] == 3) {
						answer3 += a[1] + ','
					} else if (a[0] == 4) {
						answer4 += a[1] + ','
					} else if (a[0] == 5) {
						answer5 += a[1] + ','
					}

				})
				let activityId = this.activityid;

				let params = {
					questionId: 1,
					answerCode: '',
				};
				params.answerCode = answer1
				let resultList = []

				answerCheck(activityId, params).then(res1 => {
					console.log(res1, 111)
					if (res1.code == 200) {
						resultList.unshift(res1.result.tip)

						if (res1.result.result == true) {
							console.log(111)
							this.AnswerOne = res1.result.result
						}
						var activityId = this.activityid;
						var params = {
							questionId: 2,
							answerCode: '',
						};
						params.answerCode = answer2
						answerCheck(activityId, params).then(res2 => {
							console.log(res2, 222)
							resultList.unshift(res2.result.tip)
							if (res2.code == 200) {
								if (res2.result.result == true) {
									console.log(222)
									this.AnswerTwo = res2.result.result
								}
								var activityId = this.activityid;
								var params = {
									questionId: 3,
									answerCode: '',
								};
								params.answerCode = answer3
								answerCheck(activityId, params).then(res3 => {
									console.log(res3, 333)
									resultList.unshift(res3.result.tip)
									if (res3.code == 200) {
										if (res3.result.result == true) {
											console.log(333)
											this.AnswerThree = res3.result.result
										}
										var activityId = this.activityid;
										var params = {
											questionId: 4,
											answerCode: answer4,
										};
										params.answerCode = answer4
										answerCheck(activityId, params).then(res4 => {
											console.log(res4, 444)
											resultList.unshift(res4.result.tip)
											if (res4.code == 200) {
												if (res4.result.result == true) {
													console.log(444)
													this.AnswerFore = res4.result.result
												}
												var activityId = this.activityid;
												var params = {
													questionId: 5,
													answerCode: '',
												};
												params.answerCode = answer5
												answerCheck(activityId, params).then(res5 => {
														console.log(res5, 555)
														if (res5.code == 200) {
															this.isShowDatisuccess = true
															this.is_show = true
															if (res5.result.result ==
																true) {
																this.AnswerFive = res5
																	.result.result

															}

														}
														resultList.unshift(res5.result.tip)

														let number = 0;
														if (this.AnswerOne) {
															number += 1
														}
														if (this.AnswerTwo) {
															number += 1
														}
														if (this.AnswerThree) {
															number += 1
														}
														if (this.AnswerFore) {
															number += 1
														}
														if (this.AnswerFive) {
															number += 1
														}

														if(number==5){
															this.img_show1=true
														}else if(number==4){
															this.img_show2=true
														}else if(number==3){
															this.img_show2=true
														}else if(number==2){
															this.img_show3=true
														}else if(number==1){
															this.img_show3=true
														}else if(number==0){
															this.img_show3=true
														}

														this.correctNumber = number
														console.log(number,'mmmmm')
														console.log(this.correctNumber,'nnnnnn')
												})
											}
										})
									}
								})
							}
						})
					}else{
						this.$message(res1.message)
					}
				})

				console.log(resultList, 9999999)
				this.resultList = resultList




			},
			getAnswerlist(activityid) {
                let _this = this;
				getAnswerListAll(activityid).then(res => {
					if (res.code == 200) {
						console.log(res, 2222)
						// this.result = res.result
                        for(let i in res.result){
                            for(let j in res.result[i].optionList){
                                res.result[i].optionList[j].active = 0
                            }
                        }
                        _this.$nextTick(() => {
                            _this.result = res.result;
                        });
					}
				})
			},
			_getByCode() {
				let code = "426";
				getByCode(code).then(res => {
					if (res.code == 200) {
						this.activityid = res.result.id
						console.log(this.activityid)
						this.getAnswerlist(this.activityid)
						// this._getUserParticipateInfo(this.activityid);
						this._getUserQrCode(this.activityid);
					}
				})

			},
			 _getUserParticipateInfo() {
                 let params = {
                     activityId: this.activityid,
                     isLoadRewardInfo: "1",
                 }
                 getUserParticipateInfo(this.activityid, params).then(res => {
                     console.log(res, 3333);
                     this.img_show=true;
                    //  this.levelLogo = res.result.levelLogo;
                    //  this.levelName = res.result.levelName;

                     let correctAnswerNum = res.result.correctAnswerNum;
                     let questionNum = res.result.questionNum;
                     this.correctAnswerNumDesc = questionNum + "题全部答对啦！";
                     if (correctAnswerNum > 0 && correctAnswerNum < questionNum) {
                         this.correctAnswerNumDesc = "差一点，" + questionNum + "题全对哦！";
                     } else if (correctAnswerNum == 0) {
                         this.correctAnswerNumDesc = "还差" + questionNum + "题，就能全部答对哦！";
                     }
                     if (res.result.rewardList != null && res.result.rewardList.length > 0) {
                         this.rewardDesc = res.result.rewardList[0].rewardDesc;
                         let rewardEffectiveBeginTime = res.result.rewardList[0].rewardEffectiveBeginTime;
                         let rewardEffectiveEndTime = res.result.rewardList[0].rewardEffectiveEndTime;
                         this.rewardEffective=rewardEffectiveBeginTime.split(" ")[0] + "-" + rewardEffectiveEndTime.split(" ")[0];
                         this.valueDesc = res.result.rewardList[0].valueDesc;
                     }
                 })
			 },
			_getUserQrCode(activityId) {
				let params = {
					activityId: activityId,
				}
				getUserQrCode(activityId,params).then(res => {
					if (res.code == 200) {
						this.qrCode  = res.result;
				}
			})

			},
			_answerSubmit(){

			},
			_answerSubmit1() {
				var answer1 = '';
				var answer2 = '';
				var answer3 = '';
				var answer4 = '';
				var answer5 = '';
				var num = 0
				this.form.type.forEach(item => {
					let a = item.split('')

					if (a[0] == 1) {
						answer1 += a[1] + ','
					} else if (a[0] == 2) {
						answer2 += a[1] + ','
					} else if (a[0] == 3) {
						answer3 += a[1] + ','
					} else if (a[0] == 4) {
						answer4 += a[1] + ','
					} else if (a[0] == 5) {
						answer5 += a[1] + ','
					}

				})
				let answerItems = [{
					questionId: 1,
					answerCode: ""
				}, {
					questionId: 2,
					answerCode: ""
				}, {
					questionId: 3,
					answerCode: ""
				}, {
					questionId: 4,
					answerCode: ""
				}, {
					questionId: 5,
					answerCode: ""
				}]
				answerItems[0].answerCode=answer1
				answerItems[1].answerCode=answer2
				answerItems[2].answerCode=answer3
				answerItems[3].answerCode=answer3
				answerItems[4].answerCode=answer4
				let params = {
					activityId: 1,
					answerItems: answerItems,
					source: "pc"
				}
				answerSubmit(params).then(res => {
					console.log(res, 22222333)
					if(res.code==200){
						this.subAnswer()
					}else{
						this.$message(res.message)
					}

				})
			}
		},
	}
</script>

<style>
	.answer_list {
		margin-top: -17px;
		color: #66ffdd !important;
	}

	.answer_list1 {
		margin-top: 14px;
		color: #66ffdd !important;
	}

	.answer_list2 {
		margin-top: 76px;
		color: #66ffdd !important;
	}

	.answer_list3 {

		color: #FF3E50;
	}

	.answer_list4 {
		margin-top: 14px;
		color: #FF3E50;
	}

	.answer_list5 {
		margin-top: 76px;
		color: #FF3E50;
	}

	.answer_list6 {
		margin-top: -17px;
		color: #FF3E50;
	}


	.el-form-item {
		margin-bottom: 0;
	}

	.submitAnswer {
		width: 250px;
		height: 44px;
		margin: 15px auto 0;
		background: linear-gradient(0deg, #FDCA4F 0%, #FEE571 60%, #FDF0B1 100%);
		border-radius: 22px;
		text-align: center;
		line-height: 44px;
		font-size: 16px;
		font-weight: 400;
		color: #7A4D13;
		cursor:pointer;
	}

	.el-checkbox__label {
		height: 15px;
	}

	.el-form-item__label {
		font-size: 18px;
		height: 19px;
		color: #333;
	}

	.el-form-item__content {
		height: 19px;
		margin: 0 0 29px;
	}

	.option_content2 {
		margin-bottom: 49px;
		margin-left: 9px;
		font-size: 14px;
		height: 15px;
	}

	.option_content1 {
		margin-top: 29px;
		margin-left: 9px;
		font-size: 14px;
		height: 15px;
		margin-bottom: 16px;
	}

	.form_mar {
		margin: 20px 50px 0 -83px;
		position: absolute;
		left: 83px;
		display: flex;
		flex-direction: column;
		justify-content: start;
	}

	.content_list_show1 {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: flex-start;
	}

	.option_btn {
		width: 15px;
		height: 15px;
		border: 1px solid #999999;
		border-radius: 50%;
	}

	.option1 {
		font-size: 14px;
		font-weight: 400;
		color: #333333;
		display: flex;
		justify-content: left;
		align-items: center;
	}

	.option_content {
		margin-bottom: 16px;
		margin-left: 9px;
		font-size: 14px;
		height: 15px;
	}

	.option_btn_true {
		width: 14px;
		height: 14px;
		background: #FFFFFF;
		border: 4px solid #0762DD;
		border-radius: 50%;
	}

	.option {
		margin-bottom: 16px;
		font-size: 14px;
		font-weight: 400;
		color: #333333;
		display: flex;
		justify-content: left;
		align-items: center;
	}

	.subject_mar {
		margin-top: 31px;
	}

	.subject {
		font-size: 18px;
		height: 173px;

	}

	.subject1 {
		font-size: 18px;
		height: 173px;
		margin-top: 57px;
	}

	.answer_subject {
		margin-left: 82px;
	}

	.content_list {
		/* width: 1185px; */
		/* height: 1217px; */
		background: #FFFFFF;
		border-radius: 24px;
		/* margin-left: 8px;
		margin-top: 6px; */
		padding-top: 61px;
        padding-bottom: 55px;
        box-sizing: border-box;
	}

	.content_list_show {
		display: flex;
		justify-content: flex-start;
		align-items: flex-start;
	}

	.answer_content {
		/* position: absolute; */
		width: 1200px;
		/* height: 1230px; */
		background: linear-gradient(0deg, #31CBFD 0%, #90EEF9 100%);
		border-radius: 24px;
        margin:0 auto;
        /* padding:362px 0 55px; */
        box-sizing: border-box;
        padding:8px;
		/* top: 362px;
		left: 50%;
		margin-left: -600px; */
	}


	.answer {
		background: url(./images/answerBg.png);
		background-size: 100% 100%;
		width: 100%;
		min-height: 1647px;
		min-width: 1334px;
        padding:362px 0 55px;
        box-sizing: border-box;
		/* position: relative; */
	}

    .receiveReward{
		position: absolute;
		width: 100%;
        height: 100%;
		background: rgb(0,0,0,0.7);
		z-index: 667;
    }
	.receiveReward_content{
		margin:0 auto;
		width: 373px;
		text-align: left;
	}
	.receiveReward_contentX{
		margin-left: 351px;
		margin-bottom: -12px;
	}
	.answer_box_main{
		width: 351px;
		height: 497px;
		background: url(./images/receiveReward.png) no-repeat center center;
		background-size: 100% 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		text-align: center;
	}
	.answer_box_img{
		margin:0 auto;
		padding-top: 34px;
		width: 223px;
		height: 216px;
	}
	.answer_box_img img{
		width: 100%;
		height: 100%;
	}
	.answer_box_text{
		margin-top: 30px;
		font-size: 20px;
		font-family: Source Han Sans CN;
		font-weight: bold;
		color: #404E57;
		text-align: center;
		line-height: 21px;
	}
	.answer_box_desc{
		margin-top: 13px;
		font-size: 14px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #404E57;
		text-align: center;
		line-height: 21px;
	}
	.answer_box_coupon_box{
		margin:0 auto;
		margin-top: 28px;
		width: 298px;
		height: 76px;
		background: #FEF3E2;
		box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
		border-radius: 12px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.answer_box_coupon_content{
		width: 289px;
		height: 67px;
		background: rgba(255, 255, 255, 0.6);
		border: 1px solid #FDCD52;
		border-radius: 12px;
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
	}

	.answer_box_coupon_left{
		display: flex;
		flex-direction: column;
	}
	.answer_box_coupon_text{
		font-size: 14px;
		font-family: Source Han Sans CN;
		font-weight: bold;
		color: #404E57;
		text-align: left;
	}
	.answer_box_coupon_date{
		margin-top: 9px;
		font-size: 12px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #B0B0B0;
		text-align: left;
	}
	.answer_box_coupon_line{
		height: 54px;
		border: 1px dashed #ECBF78;
		opacity: 0.5;
		margin-left: 8px;
		margin-right: 8px;
	}
	.answer_box_coupon_right{
		font-size: 20px;
		font-family: Source Han Sans CN;
		font-weight: bold;
		color: #FF3E50;
	}

	.answer_box_tip{
		margin-top: 15px;
		font-size: 12px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #B0B0B0;
		text-align: center;
		line-height: 21px;
	}

	.answer_button{
		margin:0 auto;
		margin-top: 33px;
		width: 303px;
		height: 43px;
		background: linear-gradient(0deg, #FDCA4F 0%, #FEE571 60%, #FDF0B1 100%);
		box-shadow: 0px 3px 10px 0px rgba(253, 213, 161, 0.3);
		border-radius: 20px;

		text-align: center;
		font-size: 14px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #7A4D13;
		line-height: 43px;
		cursor:pointer;
	}

	.answer_qr{
		margin:0 auto;
		margin-top: 12px;
		width: 120px;
		height: 127px;
		background: url(./images/qrbg.png) no-repeat center center;
		background-size: 100% 100%;
		text-align: center;
	}

	.answer_qr_img{
		width: 104px;
		height:104px;
		margin-top: 17px;
	}

	.answer_qr_tip{
		margin:0 auto;
		margin-top: 15px;
		width: 126px;
		height: 34px;
		font-size: 14px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #CCCCCC;
		line-height: 20px;
		text-align: center;
	}

</style>
